import React from 'react';

import styled from '@emotion/styled';
import { Country } from 'store/country/types';
import { Flag } from 'components/Flag';

type CountryOption = Country & { index: number };

const StyledOption = styled.button`
  &.select-search__option {
    align-items: center;
    display: flex;
    font-size: 24px;
    justify-content: flex-start;
    padding-left: 12px;
  }

  .country-icon {
    margin-right: 8px;
  }

  .country-name {
    font-size: 16px;
  }
`;

export function CountrySelectOption(props: unknown, option: unknown, snapshot: unknown, className: string): React.ReactNode {
  const domProps = props as any;
  const countryOption = option as CountryOption;

  return (
    <StyledOption className={className} {...domProps}>
      <Flag className="country-icon"
            countryIsoCode={countryOption.iso}
      /><span className="country-name">{countryOption.name}</span>
    </StyledOption>
  )
}
